
import { useEffect, useState } from 'react';

export default function FormSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    
    // Load the form embed script
    const script = document.createElement('script');
    script.src = 'https://web.cashflow.vip/js/form_embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script if component unmounts
      const existingScript = document.querySelector('script[src="https://web.cashflow.vip/js/form_embed.js"]');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <section id="networking-form-section" className="py-12 sm:py-16 lg:py-24 bg-black relative overflow-hidden">
      {/* Premium Background Pattern */}
      <div className="absolute inset-0">
        <div className="absolute top-10 left-4 sm:top-20 sm:left-20 w-16 h-16 sm:w-32 sm:h-32 border border-yellow-400/20 rounded-full animate-pulse"></div>
        <div className="absolute bottom-10 right-4 sm:bottom-20 sm:right-20 w-20 h-20 sm:w-40 sm:h-40 border border-yellow-400/20 rounded-full animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/4 w-12 h-12 sm:w-24 sm:h-24 border border-yellow-400/20 rounded-full animate-pulse delay-500"></div>
        <div className="absolute top-1/3 right-1/3 w-8 h-8 sm:w-16 sm:h-16 border border-yellow-400/20 rounded-full animate-pulse delay-700"></div>
      </div>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black opacity-90"></div>

      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          {/* Premium Header */}
          <div className="text-center mb-12 sm:mb-16">
            <div className="inline-flex items-center justify-center w-16 h-16 sm:w-24 sm:h-24 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-full mb-6 sm:mb-8 shadow-2xl">
              <i className="ri-vip-crown-fill text-black text-2xl sm:text-4xl"></i>
            </div>
            
            <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight">
              Acceso{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-500">
                Exclusivo
              </span>
            </h2>
            
            <p className="text-lg sm:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed px-4">
              Únete a la comunidad más selecta de emprendedores, inversionistas y dueños de negocio.
            </p>

            {/* Premium Indicators */}
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-8 mt-6 sm:mt-8">
              <div className="flex items-center space-x-3">
                <div className="w-3 h-3 bg-yellow-400 rounded-full animate-pulse"></div>
                <span className="text-gray-400 text-sm font-medium">Acceso inmediato</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-3 h-3 bg-yellow-400 rounded-full animate-pulse delay-300"></div>
                <span className="text-gray-400 text-sm font-medium">100% Gratuito</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-3 h-3 bg-yellow-400 rounded-full animate-pulse delay-600"></div>
                <span className="text-gray-400 text-sm font-medium">Comunidad verificada</span>
              </div>
            </div>
          </div>

          {/* Premium Form Container */}
          <div className="max-w-sm sm:max-w-md lg:max-w-xl mx-auto">
            <div className="relative">
              {/* Glow Effect */}
              <div className="absolute -inset-1 bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-400 rounded-2xl sm:rounded-3xl blur opacity-30 animate-pulse"></div>
              
              {/* Main Form Container */}
              <div className="relative bg-gradient-to-br from-gray-900 to-black rounded-2xl sm:rounded-3xl shadow-2xl border border-yellow-400/30 overflow-hidden">
                {/* Premium Header Bar */}
                <div className="bg-gradient-to-r from-yellow-400 to-yellow-500 px-4 sm:px-6 lg:px-8 py-3 sm:py-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-2 sm:space-x-3">
                      <div className="w-6 h-6 sm:w-8 sm:h-8 bg-black rounded-full flex items-center justify-center">
                        <i className="ri-whatsapp-fill text-yellow-400 text-sm sm:text-lg"></i>
                      </div>
                      <div>
                        <h3 className="text-sm sm:text-lg font-bold text-black">Networking VIP</h3>
                        <p className="text-black/70 text-xs">Formulario de acceso exclusivo</p>
                      </div>
                    </div>
                    <div className="flex items-center space-x-2">
                      <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                      <span className="text-black text-xs font-medium">En línea</span>
                    </div>
                  </div>
                </div>

                {/* Form Content */}
                <div className="p-4 sm:p-6 lg:p-8">
                  {/* Security Badge */}
                  <div className="bg-gradient-to-r from-gray-800 to-gray-700 rounded-lg sm:rounded-xl p-3 sm:p-4 mb-4 sm:mb-6 border border-yellow-400/20">
                    <div className="flex items-center space-x-3">
                      <div className="w-8 h-8 sm:w-10 sm:h-10 bg-yellow-400 rounded-full flex items-center justify-center">
                        <i className="ri-shield-check-fill text-black text-sm sm:text-lg"></i>
                      </div>
                      <div>
                        <h4 className="font-semibold text-white text-xs sm:text-sm">Información Protegida</h4>
                        <p className="text-gray-400 text-xs">Encriptación SSL • Datos seguros • Sin spam</p>
                      </div>
                    </div>
                  </div>

                  {/* Embedded Form with Premium Styling */}
                  <div className="relative">
                    <div className="bg-gradient-to-br from-white to-gray-50 rounded-xl sm:rounded-2xl p-1 shadow-inner">
                      <iframe
                        src="https://web.cashflow.vip/widget/form/bzfaEX2t8Mlf1lGVQ8zX"
                        style={{width:'100%', height:'450px', border:'none', borderRadius:'8px'}}
                        id="inline-bzfaEX2t8Mlf1lGVQ8zX" 
                        data-layout="{'id':'INLINE'}"
                        data-trigger-type="alwaysShow"
                        data-trigger-value=""
                        data-activation-type="alwaysActivated"
                        data-activation-value=""
                        data-deactivation-type="neverDeactivate"
                        data-deactivation-value=""
                        data-form-name="NetworkingGrupoDeWhatsapp"
                        data-height="450"
                        data-layout-iframe-id="inline-bzfaEX2t8Mlf1lGVQ8zX"
                        data-form-id="bzfaEX2t8Mlf1lGVQ8zX"
                        title="NetworkingGrupoDeWhatsapp"
                        className="shadow-lg"
                      />
                    </div>
                  </div>

                  {/* Premium Benefits Grid */}
                  <div className="mt-6 sm:mt-8 grid grid-cols-3 gap-2 sm:gap-4">
                    <div className="text-center p-2 sm:p-4 bg-gradient-to-br from-gray-800 to-gray-700 rounded-lg sm:rounded-xl border border-yellow-400/20">
                      <div className="w-6 h-6 sm:w-8 sm:h-8 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-1 sm:mb-2">
                        <i className="ri-time-fill text-black text-xs sm:text-sm"></i>
                      </div>
                      <span className="text-white text-xs font-medium">Acceso inmediato</span>
                    </div>
                    <div className="text-center p-2 sm:p-4 bg-gradient-to-br from-gray-800 to-gray-700 rounded-lg sm:rounded-xl border border-yellow-400/20">
                      <div className="w-6 h-6 sm:w-8 sm:h-8 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-1 sm:mb-2">
                        <i className="ri-gift-fill text-black text-xs sm:text-sm"></i>
                      </div>
                      <span className="text-white text-xs font-medium">100% Gratuito</span>
                    </div>
                    <div className="text-center p-2 sm:p-4 bg-gradient-to-br from-gray-800 to-gray-700 rounded-lg sm:rounded-xl border border-yellow-400/20">
                      <div className="w-6 h-6 sm:w-8 sm:h-8 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-1 sm:mb-2">
                        <i className="ri-vip-crown-fill text-black text-xs sm:text-sm"></i>
                      </div>
                      <span className="text-white text-xs font-medium">Comunidad VIP</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Trust Indicators */}
          <div className="text-center mt-8 sm:mt-12">
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-12 text-gray-500">
              <div className="flex items-center space-x-3">
                <i className="ri-lock-fill text-yellow-400 text-lg"></i>
                <span className="text-sm font-medium">Datos encriptados</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-user-star-fill text-yellow-400 text-lg"></i>
                <span className="text-sm font-medium">Miembros verificados</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-customer-service-2-fill text-yellow-400 text-lg"></i>
                <span className="text-sm font-medium">Soporte premium</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
